import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Drawer from '@mui/material/Drawer';
import ActiveTrades from './ActiveTrades.js';
import LaunchIcon from '@mui/icons-material/Launch';

function ActiveTradesDrawer(props) {

    const [drawerOpen, setDrawerOpen] = useState(false);


    return (
        <div>
            <Link className="drawer-link" onClick={() => setDrawerOpen(true)}>{props.link} <LaunchIcon fontSize='small' /></Link>
            <Drawer
                anchor={'left'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <div style={{ padding: '20px' }}>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    <br></br>

                    <h4>Active Trades</h4>
                    <ActiveTrades hideCharts={true} onlyShowUserTrades={false} userId={props.userId} accountId={props.accountId} planId={props.planId} mobileView={true} accountValue={props.accountValue} role={props.role} />
                </div>
            </Drawer>
        </div>
    );
}

export default ActiveTradesDrawer;